async function getData(setProjects) {

    await fetch("https://raw.githubusercontent.com/vinayak-singh5302/website-data/main/config.json")
        .then(response => response.json())
        .then(data => {
            setProjects(data);
        })
        .catch(e => {
            console.log(`Error : ${e}`)
        });
}

export default getData;